var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('RemoteTooltip',{attrs:{"path":`serve.php${_vm.testInfoLink}`,"additionalAttributes":_vm.additionalAttributes,"dialogAttributes":{}}},[_c('router-link',{attrs:{"to":_vm.testLink}},[_c('v-icon',[_vm._v("mdi-information")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }